import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterSingleDate_template} from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSingleDate_template';
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {filterPaymentView_template} from "./filterPaymentView_template";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {autoRefresh_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/autoRefresh_template";

declare var ko: any;

enum Frequency {
    NONE = '0',
    SEMI_MONTHLY = 'SEMI-MONTHLY',
    MONTHLY = 'MONTHLY'
}

export class centralizedPayment_template extends vnTemplate {

    protected deleteTransactionId: number;

    protected datePicker: filterSingleDate_template;
    protected frequencySelector: filterDropdown_template;

    protected pagination: pagination_template;
    protected filterPaymentView: filterPaymentView_template;
    protected filterPaymentAccount: filterDropdown_template;
    public validationsList: validationsList_template;

    protected autoRefresh: autoRefresh_template;

    protected getTemplateHtml(): string {

        return `
            <div class="sub-header">
                <div class="w-justify">
                    <div class="w-left">
                         <div>
                            <label for="frequencySelector" class="form-label form-label-box">payment frequency</label>
                            ${ this.frequencySelector.getHtmlBuild() }
                        </div>
                        <div>                            
                            <label for="singleDatePicker" class="form-label form-label-box">payment date</label>
                            ${ this.datePicker.getHtmlBuild() }
                        </div>
                    </div>
                    <div class="w-right">
                        <button id="executePaymentButton" data-bind="click: onClickExecutePayment" class="btn secondary icon i-execute" type="button">Execute Payment</button>
                        <button data-bind="click: onClickReversePayment, text: '  Revert Last Payment (' + lastPayDate() + ')'" class="btn secondary icon i-revert" type="button"></button>  
                    </div>
                </div>
                ` + this.autoRefresh.getHtmlBuild() + `
            </div>
            
            ` + this.validationsList.getHtmlBuild() + `
            
            <div class="list-header w-justify">
            
                
                <div class="w-left">
                </div>
                <div class="w-center">
                    
                </div>
                <div class="w-right">
                </div>
                          
            </div>

           <div class="w-status-report inprogress" id="list-results" data-bind="foreach: brands">        
                <div class="status-report" data-bind="css: statusClass()">
                <svg version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                  viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve">
                    <path fill="#fff" d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
                      <animateTransform 
                         attributeName="transform" 
                         attributeType="XML" 
                         type="rotate"
                         dur="1s" 
                         from="0 50 50"
                         to="360 50 50" 
                         repeatCount="indefinite" />
                  </path>
                </svg>
                    <div class="status-report-text" data-bind="css: iconImage">
                        <span class="status-report-brand" data-bind="html: name + ' <span>' + status() + '</span>'">thesportster</span>
                    </div>
                </div> 
            </div>
           
           <div id="pay-dialog" class="w-lightbox light-theme">
                <div class="lightbox-content">
                        
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Execute Payment Transactions</h3>
                            <button data-bind="event: { click: onClickPaymentDialogHide }" type="button" class="close-button icon i-close-2"></button>
                        </div>
                   
                        <div class="form-body">
                            <div class="form-group">
                                <p class="form-text">This action is irreversible</p>
                                <p class="form-text">Are you sure you want to pay all the existing transactions?</p>
                            </div>
                         </div>
                
                        <div class="form-footer">
                            <button data-bind="event: { click: onClickPaymentDialogHide }" class="btn" type="button">Cancel</button>
                            <button data-bind="event: { click: onClickPaymentConfirm }" class="btn highlight" type="button">Pay</button>
                        </div>
                    </div>
                   
                </div>
            </div>
            <div id="reverse-dialog" class="w-lightbox light-theme">
                <div class="lightbox-content">
                        
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Revert Payment</h3>
                            <button data-bind="event: { click: onClickReverseDialogHide }" type="button" class="close-button icon i-close-2"></button>
                        </div>
                   
                        <div class="form-body">
                             <div class="form-group">
                                <p class="form-text">This action is irreversible</p>
                                <p class="form-text">Are you sure you want to revert the last payment?</p>
                             </div>
                         </div>
                
                        <div class="form-footer">
                            <button data-bind="event: { click: onClickReverseDialogHide }" class="btn" type="button">Cancel</button>
                            <button data-bind="event: { click: onClickReverseConfirm }" class="btn highlight" type="button">Confirm</button>
                        </div>
                    </div>
                   
                </div>
            </div>
            <div id="none-pay-dialog" class="w-lightbox light-theme">
                <div class="lightbox-content">
                        
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Execute Payment Transactions</h3>
                            <button data-bind="event: { click: onClickPaymentDialogHide }" type="button" class="close-button icon i-close-2"></button>
                        </div>
                   
                        <div class="form-body">
                            <div class="form-group">
                                <p class="form-text">There are no transactions to pay!</p>
                             </div>
                         </div>
                
                        <div class="form-footer">
                            <button data-bind="event: { click: onClickPaymentDialogHide }" class="btn" type="button">ok</button>
                        </div>
                    </div>
                   
                </div>
            </div>
            <div id="validation-error-dialog" class="w-lightbox light-theme">
                <div class="lightbox-content">
                        
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Validation Erros</h3>
                            <button data-bind="event: { click: onClickValidationErrorDialogHide }" type="button" class="close-button icon i-close-2"></button>
                        </div>
                   
                        <div class="form-body">
                            <div class="form-group">
                                <p class="form-text">Payment Frequency Is Required</p>
                             </div>
                         </div>
                
                        <div class="form-footer">
                            <button data-bind="event: { click: onClickValidationErrorDialogHide }" class="btn" type="button">ok</button>
                        </div>
                    </div>
                </div>
            </div>
            `;
    }

    protected initPartial(): void {

        this.datePicker = new filterSingleDate_template("filterDate", this.getTemplateViewModel(), this.caller);
        this.frequencySelector = new filterDropdown_template("frequencySelector", this.getTemplateViewModel(), this.caller);

        this.filterPaymentView = new filterPaymentView_template("filterPaymentView", this.getTemplateViewModel(), this.caller);

        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this.caller);

        this.autoRefresh = new autoRefresh_template('autoRefresh_centralizedPayment', this.getTemplateViewModel(), this.caller);
        this.autoRefresh.setRefreshFrequency(30000);
    }

    public buildDatePickerCalendar() {
        this.datePicker.buildCalendarWithoutTime();
    }

    protected getTemplateName(): string {
        return "globalPayment-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let self = this;
        return {
            brands: ko.observableArray([]),
            lastPayDate: ko.observable(""),
            frequency: ko.observable(Frequency.NONE),
            onClickPaymentConfirm: (data, event) => {
                self.onClickPaymentConfirm();
            },
            onClickPaymentDialogHide: (data, event) => {
                self.onClickPaymentDialogHide();
            },
            onClickReverseConfirm: (data, event) => {
                self.onClickReverseConfirm();
            },
            onClickReverseDialogHide: (data, event) => {
                self.onClickReverseDialogHide();
            },
            onClickExecutePayment: () => {
                self.onClickExecutePaymentDialogShow();
            },
            onClickReversePayment: () => {
                self.onClickReversePaymentDialogShow();
            },
            onClickValidationErrorDialogHide: () => {
                self.onClickValidationErrorDialogHide();
            }
        }
        ;
    }


    public onClickReorder(value, data, event) {

        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.transactionPaymentListReorder();
    }

    public onClickEdit(data) {
        this.caller.editTransaction(data);
    }

    public onClickDetails(data) {
        if (data.showDetails) {
            data.showDetails = false;
            data.transactions = [];
            //force refresh - if you don't do this the foreach HTML will not be updated.
            var tmp = this.getTemplateViewModel().users();
            this.getTemplateViewModel().users([]);
            this.getTemplateViewModel().users(tmp);
        } else {
            data.showDetails = true;
            this.caller.getUserPaymentDetails(data.user_id);
        }
    }

    public setLastPayDate(lastPayDate) {
        this.viewModel[this.idElement].lastPayDate(lastPayDate);
    }

    public setPaymentDate(paymentDate): void {
        this.datePicker.setDate(paymentDate);
    }

    public setPaymentFrequencies(paymentFrequencies) {

        paymentFrequencies.unshift({id: 0, name: 'Select'});
        this.frequencySelector.setOptions(paymentFrequencies);
    }

    public setBrands(brands) {
        this.viewModel[this.idElement].brands([]);
        for (let b of brands) {
            let statusClass = b.status.replace(/\s/g, '');
            this.viewModel[this.idElement].brands.push(ko.observable({
                id: b.id,
                name: b.name,
                status: ko.observable(b.status),
                statusClass: ko.observable(statusClass),
                iconImage: b.iconImage,
            }));
        }
        // ko.applyBindings(this.viewModel[this.idElement]);
    }

    public setTransactions(transactions) {

        this.viewModel[this.idElement].transactions(transactions);

        let trxIds = [];
        if (transactions) {
            for (let t of transactions) {
                trxIds.push(t.id);
            }
        }

        this.viewModel[this.idElement].transactionIds(trxIds);
    }

    public updateStatus(brandData, status) {
        var brand = ko.utils.arrayFirst(this.viewModel[this.idElement].brands(), function (currentBrand) {
            if (typeof brandData === "object") {
                return currentBrand().id == brandData.id;
            } else {
                return currentBrand().id == brandData().id;
            }
        });


        if (brand) {
            let statusClass = status.replace(/\s/g, '');
            brand().status(status);
            brand().statusClass(statusClass);
        }

        // this.viewModel[this.idElement].brands(brands);
    }

    public onClickPaymentConfirm() {
        this.togglePaymentDialogVisibility();
        this.disablePayButton(true);
        this.caller.pay();
    }

    public onClickPaymentDialogHide() {
        this.togglePaymentDialogVisibility();
    }

    public onClickReverseConfirm() {
        this.toggleReverseDialogVisibility();

        this.caller.reverse_payment();
    }

    public onClickReverseDialogHide() {
        this.toggleReverseDialogVisibility();
    }

    public onClickHold() {
        //this.togglePaymentDialogVisibility();
    }

    public onClickExecutePaymentDialogShow() {
        console.log(this.getFrequency());
        if (this.getFrequency() == '0' ) {
            this.toggleValidationErrorDialogVisibility();
        } else {

            this.togglePaymentDialogVisibility();
        }
    }

    public onClickReversePaymentDialogShow() {
        this.toggleReverseDialogVisibility();
    }

    public onClickValidationErrorDialogHide() {
        this.toggleValidationErrorDialogVisibility();
    }

    public togglePaymentDialogVisibility() {

        document.getElementById('pay-dialog').classList.toggle('is-visible');
    }

    public toggleValidationErrorDialogVisibility() {

        document.getElementById('validation-error-dialog').classList.toggle('is-visible');
    }

    public toggleReverseDialogVisibility() {
        document.getElementById('reverse-dialog').classList.toggle('is-visible');
    }

    public setFrequency(frequency): void {

        this.getTemplateViewModel().frequency(frequency);
    }

    public getFrequency(): string {

        return this.frequencySelector.getTemplateViewModel().selectedOption();
    }

    public startAutoRefresh(): any {

        this.autoRefresh.getTemplateViewModel().toggleAutoRefresh();
        this.autoRefresh.getTemplateViewModel().callRefresh();
    }

    public disablePayButton(isToDisable){
        let payButton = <HTMLInputElement> document.getElementById('executePaymentButton');
        if(payButton){
            payButton.disabled = isToDisable;
        }
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/centralizedPayment_template.ts